<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }} {{ DefterTur }} </h1>
      <el-button-group v-if="tableDisplay || TumMod" class="float-right">

        <el-button v-if="!TumMod" type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>
        <a @click="Yazdir" class="el-button YeniBtn el-button--primary el-button--small"
        ><i class="feather-printer"></i> Yazdır
        </a>
      </el-button-group>
    </div>
    <div class="icerik" style="height: calc(100vh - 120px);">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">
          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="4">
              <el-form-item label="Site / Bina" prop="Bina_id">
                <el-select v-model="Form.Bina_id" filterable>
                  <el-option-group
                    label="Site Listesi">
                    <el-option
                      v-for="item in Siteler"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                  <el-option-group
                    label="Bina Listesi">
                    <el-option
                      v-for="item in Binalar"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Rapor Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item class="Tooltip" label="Sayfa" prop="Sayfa">
                <el-tooltip class="item"
                            effect="dark"
                            content="Başlangıç tarihi öncesindeki işlemleri devir olarak getirir."
                            placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-radio-group v-model="Form.Tur" size="mini">
                  <el-radio-button label="1">Gelir Sayfası</el-radio-button>
                  <el-radio-button label="0">Gider Sayfası</el-radio-button>
                  <el-radio-button label="2">Gelir ve Gider Sayfası</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item class="Tooltip" label="Devir" prop="Devir">
                <el-tooltip class="item" effect="dark" content="Başlanıç tarihi öncesi devir olarak getirilir"
                            placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-switch v-model="Form.Devir"></el-switch>
              </el-form-item>
            </el-col>
            <el-col v-if="Form.Tur==2" :span="2">
              <el-form-item class="Tooltip" label="Renk">
                <el-tooltip class="item" effect="dark" content="Gelir kısmı mavi gider kısmı kırmızı renk olur"
                            placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-switch v-model="Renk"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="Form.Tur==2?2:4">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay && !TumMod"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <div class="yazdirtable" v-if="!TumMod">
            <h1>{{ Sayfa.Adi }} {{ DefterTur }} </h1>
            <table class="table table-bordered">
              <thead>
              <tr>
                <th>Sıra</th>
                <th>Evrak Tarihi</th>
                <th>Evrak No</th>
                <th>Açıklama</th>
                <th class="text-right">Tutar</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="t in tableData">
                <td>{{ t.Sira }}</td>
                <td>{{ t.Tarih }}</td>
                <td>{{ t.eNo }}</td>
                <td>{{ t.Aciklama }}</td>
                <td class="text-right">{{ t.Tutar }}</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td colspan="4"></td>
                <td class="text-right">{{ AltToplam }}</td>
              </tr>
              </tfoot>
            </table>
          </div>
          <div class="yazdirtable" v-if="TumMod" style="display: block">
            <h1>{{ Sayfa.Adi }}</h1>
            <div class="row">
              <div class="col-6">

                <table class="table table-bordered" :class="Renk?'deftergelirkismi':''">
                  <thead>
                  <tr>
                    <th>Sıra</th>
                    <th>Evrak Tarihi</th>
                    <th>Evrak No</th>
                    <th>Açıklama</th>
                    <th class="text-right">Tutar</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="t in tGelir">
                    <td>{{ t.Sira }}</td>
                    <td>{{ t.Tarih }}</td>
                    <td>{{ t.eNo }}</td>
                    <td>{{ t.Aciklama }}</td>
                    <td class="text-right">{{ t.Tutar }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <td colspan="4"></td>
                    <td class="text-right">{{ tGelirAlt }}</td>
                  </tr>
                  </tfoot>
                </table>
              </div>
              <div class="col-6">
                <table class="table table-bordered" :class="Renk?'deftergiderkismi':''">
                  <thead>
                  <tr>
                    <th>Sıra</th>
                    <th>Evrak Tarihi</th>
                    <th>Evrak No</th>
                    <th>Açıklama</th>
                    <th class="text-right">Tutar</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="t in tGider">
                    <td>{{ t.Sira }}</td>
                    <td>{{ t.Tarih }}</td>
                    <td>{{ t.eNo }}</td>
                    <td>{{ t.Aciklama }}</td>
                    <td class="text-right">{{ t.Tutar }}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <td colspan="4"></td>
                    <td class="text-right">{{ tGiderAlt }}</td>
                  </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <el-table
            v-if="tableDisplay"
            class="table-xs yazdirma"
            :data="tableData"
            style="width: 100%"
            width="100%"
            show-summary
            :height="Height"
            :summary-method="TableFooter">
            <el-table-column
              label="Sıra"
              prop="Sira"
              width="50">
            </el-table-column>
            <el-table-column
              label="Evrak Tarihi"
              prop="Tarih"
              width="150">
            </el-table-column>
            <el-table-column
              label="Evrak No"
              prop="eNo"
              width="200">
            </el-table-column>
            <el-table-column
              label="Açıklama"
              prop="Aciklama">
            </el-table-column>
            <el-table-column
              label="Tutar"
              prop="Tutar"
              width="150"
              align="right">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import Yukleniyor from "../../../components/Doc/Yukleniyor";

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));


export default {
  components: {Yukleniyor},
  data() {
    return {
      Height: 0,
      DefterTur: '',
      lo: false,
      Yetki: false,
      Kaydet: false,
      Renk: false,
      Sayfa: {
        Adi: 'İşletme Defteri',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Bina_id: null,
        Tur: true,
        Devir: true,
        Tarih: []
      },
      FormHata: {
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Tur: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      MakbuzDetayModal: false,
      mNo: null,
      Kategoriler: [],
      Binalar: [],
      Siteler: [],
      tableData: [],
      ExcelData: [],
      tableDisplay: false,
      AltToplam: 0,
      TumMod: false,
      tGelir: null,
      tGider: null,
      tGelirAlt: null,
      tGiderAlt: null,

    }
  },
  methods: {

    Excel(evt) {

      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 5},
        {wch: 12},
        {wch: 10},
        {wch: 50},
        {wch: 12},
      ];

      wb.Props = {
        Title: this.Sayfa.Adi + " (" + this.DefterTur + ")",
        Author: "Aidatim APP",
        Manager: "Aidatim APP",
        Company: "Aidatim",
        Category: "Finans",
        Keywords: "Aidatim",
        Comments: this.Sayfa.Adi + " (" + this.DefterTur + ")",
      };
      XLSX.utils.book_append_sheet(wb, ws, this.DefterTur);
      XLSX.writeFile(wb, this.Sayfa.Adi + " (" + this.DefterTur + ")" + ".xlsx");
    },
    Yazdir() {
      this.$prompt('Yazdırılacak sayfanın adını değişebilirsiniz.', 'Sayfa Adı', {
        confirmButtonText: 'Yazıcıya Gönder',
        cancelButtonText: 'Vazgeç',
        inputValue: this.Sayfa.Adi,
        inputPlaceholder: 'Yazdırma Sayfası'
      }).then(({value}) => {
        this.Sayfa.Adi = value;
        this.YaziciyaGonder(value);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Yazdırma İptal Edildi'
        });
      });
    },
    YaziciyaGonder() {
      setTimeout(() => {
        window.print();
      }, 100);
    },
    TableFooter() {
      const sums = [];
      sums[4] = this.AltToplam;
      return sums;
    },
    Getir() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.TumMod = false;
          if (this.Form.Tur == 0) this.DefterTur = 'Gider Sayfası';
          if (this.Form.Tur == 1) this.DefterTur = 'Gelir Sayfası';
          if (this.Form.Tur == 2) {
            this.DefterTur = 'Gider ve Gider Sayfası';
            this.TumMod = true;
          }

          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: 'raporlama/defter'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {

                if (this.Form.Tur == 2) {

                  this.tableDisplay = false;
                  this.tGelir = response.tGelir;
                  this.tGider = response.tGider;
                  this.tGelirAlt = response.tGelirAlt;
                  this.tGiderAlt = response.tGiderAlt;

                } else {
                  this.tableData = response.tableData;
                  this.AltToplam = response.AltToplam;
                  this.ExcelData = response.ExcelData;
                  if (this.tableData) this.tableDisplay = true;
                  this.Height = window.innerHeight - 220
                }
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Binalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'muhasebe/list/site'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Siteler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    },
  },
  created() {
    this.SayfaYukle();
    this.Yetki = this.$store.getters.Yetki.raporlama == 2 ? true : false;
    var Gun = new Date();
    this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    if (this.$store.getters.BinaBilgi) {
      this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/ozel/isletmedefteri.vue